var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.40909 20.1818H1.68182C0.672727 20.1818 0 20.8545 0 21.8636V35.3182C0 36.3273 0.672727 37 1.68182 37H8.40909C9.41818 37 10.0909 36.3273 10.0909 35.3182V21.8636C10.0909 20.8545 9.41818 20.1818 8.40909 20.1818ZM35.3182 13.4545H28.5909C27.5818 13.4545 26.9091 14.1273 26.9091 15.1364V35.3182C26.9091 36.3273 27.5818 37 28.5909 37H35.3182C36.3273 37 37 36.3273 37 35.3182V15.1364C37 14.1273 36.3273 13.4545 35.3182 13.4545ZM21.8636 0H15.1364C14.1273 0 13.4545 0.672727 13.4545 1.68182V35.3182C13.4545 36.3273 14.1273 37 15.1364 37H21.8636C22.8727 37 23.5455 36.3273 23.5455 35.3182V1.68182C23.5455 0.672727 22.8727 0 21.8636 0Z",
    fill: "#649CD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartsIcon);
export default __webpack_public_path__ + "static/media/charts-icon.7b63bbcbec3b5542d34cccf4e9a1e996.svg";
export { ForwardRef as ReactComponent };